<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>VB Gerente - Devoluciones</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          <b-row>
            <b-col sm="3">
              <b-form-group label="Tipo de Validación">
                <b-form-radio v-model="datosFormulario.selected" name="some-radios" value="M">Validación Masiva</b-form-radio>
                <b-form-radio v-model="datosFormulario.selected" name="some-radios" value="I">Validación Individual</b-form-radio>
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group
                :label="crearLabel('Fecha Programada de Pago', 'fecpago', 'datosFormulario')"
                label-for="fecpago">
                <b-form-select 
                  :options="valFechas"  
                  v-model="datosFormulario.fecpago"
                  :disabled="campoBloqueado('fecpago', 'datosFormulario')"
                >
                </b-form-select>
                
                <span class="error-validacion-campo">
                  {{ mensajeValidacionCampo.fecpago }}
                </span>
              </b-form-group>
              
            </b-col>           
            
          </b-row>

          <div slot="footer">
                <div class="form-actions">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                                <b-button variant="primary" @click="pre_insertar_vb"><i class="fa fa-eraser"></i> Limpiar</b-button>
                                <b-button variant="primary" @click="descargarExcel"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                                <b-button variant="warning" @click="modalModificar = true" style="color: #ffffff; margin-left: 10px;">
                                   <i class="fa fa-edit"></i> Modificar Fecha
                                </b-button>
                                <b-button variant="success" @click="modalAutorizar = true" style="color: #ffffff; margin-left: 10px;" v-show="datosFormulario.selected == 'M'? true : false">
                                  <i class="fa fa-save"></i> Autorizar
                                </b-button>
                                <b-button variant="danger" @click="modalRechazar = true" style="color: #ffffff; margin-left: 10px;" v-show="datosFormulario.selected == 'M'? true : false">
                                  <i class="fa fa-save"></i> Rechazar
                                </b-button>
                            </el-col> 
                               
                    </el-row>                
                </div>
            </div>            
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>  
        <b-card v-if="mostrarInfo">
          <div>
          <b-alert variant="info" show>
            Número total de casos <strong>Autorizados</strong> para la fecha seleccionada <strong>({{datosFormulario.autorizados}})</strong>.
            <br>
            Número total de casos <strong>Pendientes</strong> para la fecha seleccionada <strong>({{datosFormulario.pendientes}})</strong>.
            <br>
            Número total de casos <strong>Rechazados</strong> para la fecha seleccionada <strong>({{datosFormulario.rechazados}})</strong>.
          </b-alert>
          </div>            
        </b-card>
      </b-col>
    </b-row>

    <b-card v-if="tieneAcceso === true" v-show="datosFormulario.selected == 'M'? true : false">
          <div slot="header">
            <strong>VB Gerente - Devoluciones</strong>
          </div>
          <b-row>
            <b-col lg="6"></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable1"
                  :data="data"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  @selection-change="handleSelectionChange">
                >
                 <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    sortable="custom"
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  >
                  <template slot-scope="scope">
                    <div v-if="title.prop == 'BENEFICIARIO'">  
                        <el-button type="text" v-if="scope.row.CANTBENEFI > 1" @click="detalleBeneficiarios(scope.row.SINIESTRO, true)">Beneficiarios ({{scope.row.BENEFICIARIO}})</el-button>   
                        <p v-else >{{scope.row.BENEFICIARIO}}</p>
                    </div>
                    <p v-else>{{scope.row[title.prop]}}</p>
                  </template>
                  </el-table-column>

                  <el-table-column label="Documentación" min-width="100px" align="center">
                  <template slot-scope="scope">
                    <el-tooltip
                        v-for="button in customButtonsForRowDoc(scope.row)"
                        :key="button.id"
                        :content="button.tooltip"
                        placement="top">
                        <el-button
                          type="text"
                          @click="button.handler"
                        >
                          <i v-bind:class="button.icon"></i>
                          {{ button.name }}
                        </el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
                  <el-table-column  type="selection" width="35" reserve-selection><!-- reserve-selection -->
                  </el-table-column>
                </data-tables>
              </div>
            </b-col>
          </b-row>
    </b-card>

    <b-card v-if="tieneAcceso === true" v-show="datosFormulario.selected == 'I'? true : false">
          <div slot="header">
            <strong>Validación Gerente del Area</strong>
          </div>
          <b-row>
            <b-col lg="6"></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable1B"
                  :data="data"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table">
                >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    sortable="custom"
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  >
                  </el-table-column>
                  <el-table-column label="Documentación" min-width="100px" align="center">
                  <template slot-scope="scope">
                    <el-tooltip
                        v-for="button in customButtonsForRowDoc(scope.row)"
                        :key="button.id"
                        :content="button.tooltip"
                        placement="top">
                        <el-button
                          type="text"
                          @click="button.handler"
                        >
                          <i v-bind:class="button.icon"></i>
                          {{ button.name }}
                        </el-button>
                    </el-tooltip>
                  </template>
                  </el-table-column>
                  <el-table-column label="Revisión GS" min-width="100px" align="center">
                  <template slot-scope="scope">
                    <el-tooltip
                        v-for="button in customButtonsForRow(scope.row)"
                        :key="button.id"
                        :content="button.tooltip"
                        placement="top">
                        <el-button
                          type="text"
                          @click="button.handler"
                        >
                          <i v-bind:class="button.icon"></i>
                          {{ button.name }}
                        </el-button>
                    </el-tooltip>
                  </template>
                  </el-table-column>
                </data-tables>
              </div>
            </b-col>
          </b-row>
    </b-card>

    <!-- Resumen del Caso -->
  <b-modal
      size="lg"
      title="Calcular Devolucion"
      cancel-title="Rechazar"
      ok-title="Autorizar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalCalDevolucion"
      @ok="autorizarIndividual"
      @cancel="rechazarIndividual"
    >
      <b-row>
        <b-col lg="12">
          <b-tabs lazy>
            <b-tab title="Calculo de Devolución">
              
              <b-row>
                <b-col sm="6">
                  <label for="input-small">Estado del siniestro</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="desestado" size="sm" placeholder="Estado del Siniestro" class="mt-1" v-model="datosCalcDevolucion.desestado" :disabled="true"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small">Fecha estimada de configuracion</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="festconfig" size="sm" placeholder="Fecha estimada de configuracion" class="mt-1" v-model="datosCalcDevolucion.festconfig" :disabled="true" :formatter= "formatter" ></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small">Tratamiento del recupero</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="tratamiento" size="sm" placeholder="Tratamiento del recupero" class="mt-1" v-model="datosCalcDevolucion.tratamiento" :disabled="true"></b-form-input>
                </b-col>
              </b-row>
              
              <b-row>
                <b-col sm="6">
                  <label for="input-small">Reglas</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="reglas" size="sm" placeholder="Reglas" class="mt-1" v-model="datosCalcDevolucion.reglas" :disabled="true"></b-form-input>
                </b-col>
              </b-row>
              
              <b-row>
                <b-col sm="6">
                  <label for="input-small">Moneda de la póliza</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="sndmoneda" size="sm" placeholder="Moneda de la póliza" class="mt-1" v-model="datosCalcDevolucion.sndmoneda" :disabled="true"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small">Moneda de la devolución</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="slqmoneda" size="sm" placeholder="Moneda de la devolución" class="mt-1" v-model="datosCalcDevolucion.slqmoneda" :disabled="true"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small">Coaseguro (%)</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="sndcoaseguro" size="sm" placeholder="Coaseguro (%)" class="mt-1" v-model="datosCalcDevolucion.sndcoaseguro" :disabled="true" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small" >Parte Cubierta (%)</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="partcubierta" size="sm" placeholder="Parte Cubierta (%)" class="mt-1" v-model="datosCalcDevolucion.partcubierta" :disabled="true" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>
              
              <b-row>
                <b-col sm="6">
                  <label for="input-small" >Recepción Informe</label>
                </b-col>
                <b-col sm="6">
                  <b-input-group>
                  
                  <b-form-input id="ilqfrecepcion" size="sm" placeholder="Recepción Informe" class="mt-1" v-model="datosCalcDevolucion.ilqfrecepcion" :disabled="true"></b-form-input>
                  <b-input-group-append>
                    <b-button v-if="datosCalcDevolucion.informe != undefined" size="sm" block  variant="info" @click="buscarInformeCorreo(datosCalcDevolucion.informe)" style="color: #ffffff;" class="mt-1" v-b-tooltip.hover title="Ver Informe"> <i class="fa fa-file-pdf-o"> </i></b-button>
                    <b-button v-if="datosCalcDevolucion.correo != undefined" size="sm" block  variant="info" @click="buscarInformeCorreo(datosCalcDevolucion.correo)" style="color: #ffffff;" class="mt-1" v-b-tooltip.hover title="Ver Correo"> <i class="fa fa-envelope-o"> </i></b-button>
                  </b-input-group-append>
                </b-input-group>

                </b-col> 
              </b-row>
            
              <br>
              <!-- <label for="input-small">--------------------------------------------------------------------------------------------------------------------------------------------------------</label> -->
              <b-row>
                <b-col sm="6">
                  
                </b-col>
                <b-col sm="3" align="center">
                  <b><label for="input-small">Moneda póliza</label></b>
                </b-col>
                <b-col sm="3" align="center">
                  <b><label for="input-small">Pesos</label></b>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <label for="input-small" class="mt-1">Recuperos del período</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtorecmoneda" size="sm" align="right" placeholder="Moneda póliza" v-model="datosCalcDevolucion.mtorecmoneda" :disabled="true" style="text-align:right"></b-form-input>    
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtorecpesos" size="sm" align="right" placeholder="Pesos" v-model="datosCalcDevolucion.mtorecpesos" :disabled="true" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small" class="mt-1">Gastos (AB+CO+PE) del periodo</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtogastosmoneda" size="sm" placeholder="Moneda póliza" class="mt-1" v-model="datosCalcDevolucion.mtogastosmoneda" :disabled="true" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtogastospesos" size="sm" placeholder="Pesos" class="mt-1" v-model="datosCalcDevolucion.mtogastospesos" :disabled="true" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <b><label for="input-small" class="mt-1">Monto a devolver en este proceso</label></b>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtodevmoneda" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.mtodevmoneda" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtodevpesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.mtodevpesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small" class="mt-1">Monto impago total</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtoimpagomoneda" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.mtoimpagomoneda" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtoimpagopesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.mtoimpagopesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small" class="mt-1">Total pagos al beneficiario</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="totpagosmoneda" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.totpagosmoneda" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="totpagospesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.totpagospesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small" class="mt-1">Saldo actual por devolver</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="saldoactualmoneda" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.saldoactualmoneda" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="saldoactualpesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.saldoactualpesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <b><label for="input-small" class="mt-1">Monto a devolver es menor al saldo</label></b>
                </b-col>
                <b-col sm="3" >
                  <b-form-input id="mtodevok" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.mtodevok" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtodevokpesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.mtodevokpesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>
              
              <b-row>
                <b-col sm="6">
                  <label for="input-small" class="mt-1">Reliquidación devolver recuperos</label>
                </b-col>
                <b-col sm="3" >
                  <b-form-input id="reliqmoneda" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.reliqmoneda" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="reliqpesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.reliqpesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>
              <br>

              <b-row> 
                <b-col sm="12">
                  <b-form-textarea
                    id="comentarioval"
                    v-model="datosCalcDevolucion.comentarioval"
                    placeholder="Comentarios para el validador"
                    rows="2"
                    max-rows="2"
                    :disabled="true"
                  ></b-form-textarea>
                  
                </b-col>
                </b-row> 

              <br> 

            <div v-if="datosCalcDevolucion.devOtroMonto != 0">
              <b-row>  
                <b-col lg="4">
                </b-col>
                <b-col lg="4" class="pb-10"> 
                </b-col>
                <b-col sm="4">
                  <b-button size="sm" block  variant="info" @click="accionBoton('otroMonto')" style="color: #ffffff;">Devolver otro monto</b-button>
                  <br>
                    <b-row>
                      <b-col sm="12">
                         <b-input-group>
                          <b-form-input id="devMonOtroMonto" size="sm" placeholder="devMonOtroMonto" :disabled="true" v-model="datosCalcDevolucion.devMonOtroMonto"></b-form-input>
                          <b-input-group-append>
                            <b-form-input id="devOtroMonto" size="sm" placeholder="devOtroMonto" :disabled="true" v-model="datosCalcDevolucion.devOtroMonto" style="text-align:right"></b-form-input>
                          </b-input-group-append>
                        </b-input-group> 
                      </b-col>
                    </b-row>  
                </b-col>
              </b-row>
            </div>
            
            </b-tab>

            <b-tab title="Beneficiarios">
              <br/>
              <b-row>
                <el-table 
                  ref="refTable3"
                  :data="dataBeneficiarios"
                  style="width: 100%"
                  border
                  max-height="400px"
                  :row-class-name="tableRowClassName">

                  <el-table-column
                    v-for="title in titlesBeneficiarios"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  ></el-table-column>
                </el-table>
              </b-row>
              <br>

            </b-tab>  
          </b-tabs>

          
        </b-col>
      </b-row>
    </b-modal>

    <!-- Observacion -->
    <b-modal
      title="Observación"
      cancel-title="Omitir"
      ok-title="Guardar"
      class="modal-success"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      v-model="modalObservacion"
      @ok="confirmaRechazo(true);"
      @cancel="confirmaRechazo(false)"
    >
      <b-form-textarea
        id="obs"
        v-model="modalDataObservacion.observacion"
        placeholder="Ingrese la observación (Opcional)."
        rows="3"
        max-rows="6"
      ></b-form-textarea>
    </b-modal>

    <!-- Autorizacion Masiva -->
    <b-modal
      title="Autorización Masiva"
      cancel-title="Cancelar"
      ok-title="Autorizar"
      class="modal-success"
      v-model="modalAutorizar"
      @ok="autorizar();"
      @cancel="modalAutorizar = false"
    >
        Se autorizaran todos los registros marcados.  
    </b-modal>

    <!-- Rechazar Masiva -->
    <b-modal
      title="Rechazar Masivo"
      cancel-title="Cancelar"
      ok-title="Rechazar"
      class="modal-success"
      v-model="modalRechazar"
      @ok="rechazarMasivo();"
      @cancel="modalRechazar = false"
    >
        Se rechazaran todos los registro marcados.  
    </b-modal>

      <!-- Detalle Beneficiarios -->
    <b-modal
      size="lg"
      ok-only
      title="Beneficiarios"
      cancel-title="Cancelar"
      ok-title="Cerrar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalBeneficiarios"
      @ok="modalBeneficiarios = false"
      @cancel="modalBeneficiarios = false"
    >
      <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable3"
                  :data="dataBeneficiarios"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                >
                  <el-table-column
                    v-for="title in titlesBeneficiarios"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  ></el-table-column>
                </data-tables>
              </div>
            </b-col>
          </b-row>
    </b-modal>

    <b-modal
      title="Modificación Fecha Programada de Pago"
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      v-model="modalModificar"
      @ok="modificarfecha();"
      @cancel="modalModificar = false"
    >
      <b-input-group>
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="fa fa-calendar"></i>
            </span>
          </div>
          <datepicker
             :language="es" 
             format="dd/MM/yyyy"
             :use-utc="true"
             input-class="form-control" 
            v-model="datosFormulario.hoy"
          ></datepicker>
          <span class="error-validacion-campo">{{ mensajeValidacionCampo.hoy }}</span>
        </b-input-group>
        <br>
        Se modificará la "Fecha Programada de Pago" de los registros marcados con la fecha seleccionada.  
      </b-modal>

  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiDevolucion from "@/components/services/apiDevolucion";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import numeral from "numeral";

import XLSX from "xlsx";

export default {
  name: "vbgerente",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      exportar: false,
      tieneAcceso: true,
      mostrarInfo: false,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },

      data: [],
      modalCalDevolucion: false,
      modalModificar: false,
      dataDetalle: [],
      dataBeneficiarios: [],
      nombreexcel: "vbgerente",
     titles: [
        {
          prop: "ASEGURADO",
          label: "Asegurado",
          align: "left",
          minwidth: "220",
        },
        {
          prop: "BENEFICIARIO",
          label: "Beneficiario",
          align: "left",
          minwidth: "220",
        },
        {
          prop: "PRODUCTO",
          label: "Producto",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "POLIZA",
          label: "Póliza",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "ESTADO",
          label: "Estado",
          align: "center",
          minwidth: "80",
        },
        {
          prop: "SINIESTRO",
          label: "Siniestro",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "DEUDOR",
          label: "Deudor",
          align: "left",
          minwidth: "200",
        },
        {
          prop: "SLQMONEDADEV",
          label: "Mon. de la devolución",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "SLQMONTODEV",
          label: "Mto. a devolver",
          align: "right",
          minwidth: "130",
        },
        {
          prop: "SLQMTODEVMONPOL",
          label: "Mto. a devolver Mon. Pol",
          align: "right",
          minwidth: "140",
        },
        // {
        //   prop: "MONTOPESOS",
        //   label: "Mto. a devolver Mon. $",
        //   align: "right",
        //   minwidth: "140",
        // },
        {
          prop: "TIPO",
          label: "Tipo",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "ESTADORECU",
          label: "Estado del recupero",
          align: "center",
          minwidth: "150",
        }
      ],

      titlesBeneficiarios: [
        {
          prop: "SBCCODBENEF",
          label: "Codigo",
          align: "center",
          minwidth: "80",
        },
        {
          prop: "SBCIDNACBENEF",
          label: "Id Nación",
          align: "right",
          minwidth: "100",
        },
        {
          prop: "SBCNOMBENEF",
          label: "Razón Social",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "SBCMONEDA",
          label: "Moneda",
          align: "center",
          minwidth: "80",
        },
        {
          prop: "SBCMONTO",
          label: "Monto",
          align: "right",
          minwidth: "100",
        },
        {
          prop: "SBCPORCENTAJE",
          label: "Porcentaje",
          align: "center",
          minwidth: "100",
        }
      ],

      mostrarFechas: true,
      datosFormulario: {
        codejecutivo: "",
        fdesde: "",
        fhasta: "",
        totseleccion: 0,
        totbenef: 0,
        hoy:""
      },

      datosCalcDevolucion: {
        desestado: "",
        festconfig: "",
        tratamiento: "",
        reglas: "",
        sndmoneda:"",
        slqmoneda:"",
        sndcoaseguro: "",
        partcubierta: "",
        mtodevmoneda: "",
        mtodevpesos: "",
        mtoimpagomoneda: "",
        mtoimpagopesos: "",
        totpagosmoneda: "",
        totpagospesos: "",
        saldoactualmoneda: "",
        saldoactualpesos: "",
        mtodevok: "",
        mtodevokpesos: "",
        ilqfrecepcion: "",
        informe: "",
        correo: "",
        devolucion:"",
        reliqmoneda: "",
        reliqpesos:"",
        mtogastospesos: "",
        mtogastosmoneda: "",
        mtorecmoneda: "",
        mtorecpesos: "",
        siniestro:"",
        slqdevolucion:"",
        estado:"",
        devMonOtroMonto:"",
        devOtroMonto:"",
        comentarioval:""
      },

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              if (prop === 'Fecha Est. Config'){
                let elDate = new Date(row["Fecha Est. Config"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              } else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }
            })
            
          }
        }
      ],

      titlesDetalle: [
        {
          prop: "Item",
          label: "Item",
          align: "left",
        },
        {
          prop: "Monto $",
          label: "Monto $",
          align: "right",
          minwidth: "50",
        },
        {
          prop: "Moneda",
          label: "Moneda Póliza",
          align: "center",
        },
        {
          prop: "Monto Moneda Póliza",
          label: "Monto Moneda Póliza",
          align: "right",
          minwidth: "70",
        }
      ],
      filters2: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              if (prop === 'Fecha Est. Config'){
                let elDate = new Date(row["Fecha Est. Config"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              } else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }
            })
            
          }
        }
      ],

      valFechas: [],
      
      datosFormulario: {
        fecpago: "",
        selected: "",
        pendientes: 0,
        autorizados: 0,
        rechazados: 0,
      },

      datosFormularioDetalle: {
        coaseguro: "",
        parte_cubierta: "", 
        tipo: "",
        fecha_publicacion: "",
        monto_impto: "",
        no_nd: "",
        observaciones: "",
        fecha: "",
        instancia: "",
        porc: "",
        monto: "",
        obsexec: ""
      },

      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      modalDetalle: false,
      modalDataDetalle: {},

      modalBeneficiarios: false,

      modalObservacion: false,
      modalDataObservacion: {
        observacion: "",
        slqdevolucion: "",
        individual: true
      },

      modalAutorizar: false,
      modalRechazar: false,

      multipleSelection: [],
      multipleSelectionModificar: [],

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        rowKey: "Siniestro",
        rowClassName({ row, rowIndex}) {
            if(row.VBGS == "R"){
                return 'warning-row';
            }
            else{
                return 'estiloFilaTabla';
            }
        }
      },
    };
  },
  components:{
    Datepicker
  },
  methods: {

     buscarInformeCorreo(p_ruta) {
      this.$session.start(); 
      window.open(p_ruta, '_blank')
     
    },
    
    customButtonsForRowDoc(row) {
          var botones = new Array();
          
          if (row.INFORME)
          {
            var obj = new Object();
            obj.tooltip = "Informe Liquidación";
            obj.id = 1;
            obj.name="";
            obj.icon = "fa fa-file-pdf-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                window.open(row.INFORME, '_blank');
            }
            botones.push(obj);
          }

          if (row.CORREO)
          {
            var obj = new Object();
            obj.tooltip = "Correo";
            obj.id = 2;
            obj.name="";
            obj.icon = "fa fa-envelope-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                window.open(row.CORREO, '_self');
            }
            botones.push(obj);
          }
          
          return botones;

    },

    customButtonsForRow(row) {
          var botones = new Array();
          
          var obj = new Object();
            obj.tooltip = "Detalle de la Devolución";
            obj.id = 1;
            obj.name="";
            obj.icon = "fa fa-pencil-square-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                this.recuperar_devolucion(row);
            }
            botones.push(obj);
          
          
          return botones;

    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.refTable1.$children[0].toggleRowSelection(row);
        });
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    mergeArrayObjects(arr1,arr2){
      return arr1.map((item,i)=>{
        if(item.id === arr2[i].id){
            //merging two objects
          return Object.assign({},item,arr2[i])
        }
      })
    },

    formatNumber(n) {
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();
              
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    tableRowClassName({ row }) {
      if(row.marca == "1"){
            return 'warning-row';
        }
        else{
            return 'estiloFilaTabla';
        }
      
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },
    
    pre_insertar_vb() {
      this.mostrarInfo = false;
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.data2 = [];
      this.data3 = [];
      return apiDevolucion
        .pre_insercion_vb(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then(response => {
          response.data = this.keysMinuscula(response.data);

        //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }
          
          var lista_data = response.data.res;
          for(var i = 0; i < lista_data.length; i++){
              this.datosFormulario.fecpago = this.convierteFecha(lista_data[i]["fecpago"]);
              this.datosFormulario.selected = lista_data[i]["tipoval"];
              this.datosFormulario.pendientes = lista_data[i]["pendientes"];
              this.datosFormulario.autorizados = lista_data[i]["autorizados"];
              this.datosFormulario.rechazados = lista_data[i]["rechazados"];
              this.datosFormulario.hoy = lista_data[i]["hoy"];
          }
      
          this.datosFormularioEstado = response.data.festado;
          
          //Carga lista de fechas
          var tiposFecha = new Array();
          var lista_tipos_fecha = response.data.fechas;
          for(var i = 0; i < lista_tipos_fecha.length; i++){
              var obj = new Object();
              obj.value = this.convierteFecha(lista_tipos_fecha[i]["snpfecha"]);
              obj.text = this.convierteFecha(lista_tipos_fecha[i]["snpfecha"]);
              tiposFecha.push(obj);
          }
          this.valFechas = tiposFecha;
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();
      //console.log(this.datosFormulario.fecpago);
      return apiDevolucion
        .recuperar_vbgerente(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.fecpago, 
          this.datosFormulario.selected
        )
        
        .then(response => {
          this.data  = response.data.res1;
          this.pagina = this.paginaAnterior;

          this.$Progress.finish();

          this.datosFormulario.pendientes = response.data.args_out.pendientes;
          this.datosFormulario.autorizados = response.data.args_out.autorizados;
          this.datosFormulario.rechazados = response.data.args_out.rechazados;

          if (this.data != null){
            this.mostrarInfo = true;
            this.exportar = true;
          } else {
            this.exportar = false;
          }
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },
  
recuperar_devolucion(row){
      this.$Progress.start();
           apiDevolucion
           .recuperar_resumen(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            row.SINIESTRO,
            row.SLQDEVOLUCION
          )
          
           .then(response => {
             this.dataCalDevolucion = response.data.res1;  
             console.log(response.data.res1);
             this.modalCalDevolucion = true;
            
            if (response.data.res1.length > 0) {
                this.mostrarOpciones = false;
                this.opcionesOtroMonto = false;
                this.dataCalDevolucion.slqdevolucion = response.data.res1[0].SLQDEVOLUCION;
                this.datosCalcDevolucion.desestado = response.data.res1[0].SNDESTADO;
                this.datosCalcDevolucion.festconfig = this.convierteFecha(response.data.res1[0].SNDFESTCONFIG);
                this.datosCalcDevolucion.tratamiento = response.data.res1[0].TRATAMIENTO;
                this.datosCalcDevolucion.reglas = response.data.res1[0].REGLAS;
                this.datosCalcDevolucion.sndmoneda = response.data.res1[0].SNDMONEDA;
                this.datosCalcDevolucion.slqmoneda = response.data.res1[0].SLQMONEDA;
                // this.$numeral(row[column.property]).format("0,0.00")
                this.datosCalcDevolucion.sndcoaseguro = response.data.res1[0].SNDCOASEGURO
                this.datosCalcDevolucion.partcubierta = response.data.res1[0].PARTCUBIERTA
                this.datosCalcDevolucion.tratamiento = response.data.res1[0].TRATAMIENTO;
                this.datosCalcDevolucion.ilqfrecepcion = this.convierteFecha(response.data.res1[0].ILQFRECEPCION);
                
                this.datosCalcDevolucion.informe = response.data.res1[0].INFORME;
                this.datosCalcDevolucion.correo = response.data.res1[0].CORREO;

                this.datosCalcDevolucion.mtodevmoneda = this.$numeral(response.data.res1[0].MTODEVMONEDA).format("0,0.00");
                this.datosCalcDevolucion.mtodevpesos = this.$numeral(response.data.res1[0].MTODEVPESOS).format("0,0");

                this.datosCalcDevolucion.mtorecmoneda =  this.$numeral(response.data.res1[0].MTORECMONEDA).format("0,0.00");
                this.datosCalcDevolucion.mtorecpesos = this.$numeral(response.data.res1[0].MTORECPESOS).format("0,0");

                this.datosCalcDevolucion.mtogastosmoneda = this.$numeral(response.data.res1[0].MTOGASTOSMONEDA).format("0,0.00");
                this.datosCalcDevolucion.mtogastospesos = this.$numeral(response.data.res1[0].MTOGASTOSPESOS).format("0,0");
                
                this.datosCalcDevolucion.mtoimpagomoneda = this.$numeral(response.data.res1[0].MTOIMPAGOMONEDA).format("0,0.00");
                this.datosCalcDevolucion.mtoimpagopesos = this.$numeral(response.data.res1[0].MTOIMPAGOPESOS).format("0,0");

                this.datosCalcDevolucion.totpagosmoneda = this.$numeral(response.data.res1[0].TOTPAGOSMONEDA).format("0,0.00");
                this.datosCalcDevolucion.totpagospesos = this.$numeral(response.data.res1[0].TOTPAGOSPESOS).format("0,0");

                this.datosCalcDevolucion.saldoactualmoneda = this.$numeral(response.data.res1[0].SALDOACTUALMONEDA).format("0,0.00");
                this.datosCalcDevolucion.saldoactualpesos = this.$numeral(response.data.res1[0].SALDOACTUALPESOS).format("0,0");

                this.datosCalcDevolucion.mtodevok = response.data.res1[0].MTODEVOK;
                this.datosCalcDevolucion.mtodevokpesos = response.data.res1[0].MTODEVOKPESOS;

                this.datosCalcDevolucion.reliqmoneda = this.$numeral(response.data.res1[0].RELIQMONEDA).format("0,0.00");
                this.datosCalcDevolucion.reliqpesos = this.$numeral(response.data.res1[0].RELIQPESOS).format("0,0");

                this.datosCalcDevolucion.devMonOtroMonto = response.data.res1[0].DEVMONOTROMONTO;
                this.datosCalcDevolucion.devOtroMonto = this.$numeral(response.data.res1[0].DEVOTROMONTO).format("0,0");

                this.datosCalcDevolucion.comentarioval = response.data.res1[0].COMENTARIOVALDEV;

            }

             this.detalleBeneficiarios(row.SINIESTRO, false);
             this.$Progress.finish();

          })
          .catch(error => {
            this.modalCalDevolucion = false;
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    },

    formatter(row, column) {
      if (column.property == "prifmodif" && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      } else if (column.property == "MONTO" && row[column.property] ||
                 column.property == "Monto $" && row[column.property] ||
                 column.property == "Monto Moneda Póliza" && row[column.property]) {
        column.align = "is-right";
        
        return this.$numeral(row[column.property]).format("0,0.00");
      } else {
        return row[column.property];
      }
      
    },
    
    descargarExcel: function () {
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      //cuerpo += "<td height=28 class=xl159618 style='height:21.0pt;"+xl159618+"'></td>\n";
      cuerpo +=
        "<td colspan=" +
        columnas.length +
        " class=xl689618 style='border-right:.5pt solid black;" +
        xl689618 +
        "' >Validación VB gerente - Devoluciones al " +
        this.datosFormulario.fecpago +
        "</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo += "</tr>\n";
      
      //Data bloque 1
      for (var key in this.data) {
        if(this.data[key]["ASEGURADO"] == undefined){
          this.data[key]["ASEGURADO"] = "";
        }
        if(this.data[key]["BENEFICIARIO"] == undefined){
          this.data[key]["BENEFICIARIO"] = "";
        }
        if(this.data[key]["PRODUCTO"] == undefined){
          this.data[key]["PRODUCTO"] = "";
        }
        if(this.data[key]["POLIZA"] == undefined){
          this.data[key]["POLIZA"] = "";
        }
        if(this.data[key]["ESTADO"] == undefined){
          this.data[key]["ESTADO"] = "";
        }
        if(this.data[key]["SINIESTRO"] == undefined){
          this.data[key]["SINIESTRO"] = "";
        }
        if(this.data[key]["EJECUTVO"] == undefined){
          this.data[key]["EJECUTVO"] = "";
        }
       
        if(this.data[key]["DEUDOR"] == undefined){
          this.data[key]["DEUDOR"] = "";
        }
        if(this.data[key]["MONEDAPOL"] == undefined){
          this.data[key]["MONEDAPOL"] = "";
        }
        if(this.data[key]["MONTO"] == undefined){
          this.data[key]["MONTO"] = "";
        }
        if(this.data[key]["MONTOPESOS"] == undefined){
          this.data[key]["MONTOPESOS"] = "";
        }
        if (this.data[key]["SLQMONEDADEV"] == undefined){
          this.data[key]["SLQMONEDADEV"] = "";
        }
        if (this.data[key]["SLQMONTODEV"] == undefined){
          this.data[key]["SLQMONTODEV"] = "";
        }
        if (this.data[key]["SLQMTODEVMONPOL"] == undefined){
          this.data[key]["SLQMTODEVMONPOL"] = "";
        }

        if(this.data[key]["TIPO"] == undefined){
          this.data[key]["TIPO"] = "";
        }
        if(this.data[key]["ESTADORECU"] == undefined){
          this.data[key]["ESTADORECU"] = "";
        }
       
        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ASEGURADO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["BENEFICIARIO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["PRODUCTO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["POLIZA"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ESTADO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["SINIESTRO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["DEUDOR"] + "</td>\n";   
        // cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["MONEDAPOL"] + "</td>\n";
        // cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["MONTO"]).format("0,0.00") + "</td>\n";
        // cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["MONTOPESOS"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["SLQMONEDADEV"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["SLQMONTODEV"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["SLQMTODEVMONPOL"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["TIPO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ESTADORECU"] + "</td>\n";

        cuerpo += "</tr>\n";
      }

      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export:async function(data, filename) {
        if(typeof this.beforeFinish === 'function')
          await this.beforeFinish();
        download(data, filename,  "application/vnd.ms-excel");
      },

    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },

    modificar(){
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.SLQDEVOLUCION);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["SLQDEVOLUCION"])){
         //   console.log(this.multipleSelection[index]["SLQDEVOLUCION"]);
            marcados.push(this.multipleSelection[index]);
          }
      }

      this.multipleSelectionModificar = marcados;

      if (this.multipleSelectionModificar.length > 0){
       // console.log(this.multipleSelectionModificar);
        this.modalModificar = true;

      }else{
        this.crearNotificacion(
                "Marcar para Pago",
                "No tiene siniestros seleccionados para cambiar la Fecha Programada de Pago.",
                "error"
              );
      }
      
    },

    autorizarIndividual(){
      this.$Progress.start();
      this.modalCalDevolucion = false;
    
   // console.log(this.dataCalDevolucion.slqdevolucion);
        apiDevolucion
          .autorizar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.dataCalDevolucion.slqdevolucion
          )
          .then(response => {
            this.$Progress.finish();
            this.crearNotificacion(
                "Autorizar",
                "Se han guardado las autorizaciones seleccionas.",
                "success"
              );
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    },

    modificarfecha(){
      this.$Progress.start();
      
      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.SLQDEVOLUCION);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["SLQDEVOLUCION"])){
            marcados.push(this.multipleSelection[index]);
          }
      }
      /* -- */
      var NroDevolucionMarcados = "";
      var index = 0;
      
      for (index = 0; index < marcados.length; ++index) {
        NroDevolucionMarcados += marcados[index]["SLQDEVOLUCION"] + ',';
      }
      
      if (NroDevolucionMarcados != ""){
        NroDevolucionMarcados = NroDevolucionMarcados.slice(0, -1)
        apiDevolucion
          .modificarfecha(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormulario.hoy,
            NroDevolucionMarcados
          )
          .then(response => {
            this.$Progress.finish();
            this.crearNotificacion(
                "Modificar Fecha",
                 "Se modificó la fecha de pago de todos los siniestros seleccionados",
                "success"
              );                          
             this.pre_insertar_vb().then(response => {this.buscar()});
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
    },
    
  validarDesmarcados(){
      var ret = false;
      this.multipleSelectionDelete = [];
      for (var index = 0; index < this.data.length; ++index) {
          if (this.data[index]["chk"] == "1"){
            if (!this.multipleSelection.includes( this.data[index])){
              this.multipleSelectionDelete.push(this.data[index]);
              ret = true;
            }
          }
      }
      return ret;
    },

    autorizar(){
      this.$Progress.start();

      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.SLQDEVOLUCION);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["SLQDEVOLUCION"])){
            marcados.push(this.multipleSelection[index]);
          }
      }

      var siniestrosMarcados = "";
      var index = 0;
      for (index = 0; index < marcados.length; ++index) {
          siniestrosMarcados += marcados[index]["SLQDEVOLUCION"] + ',';
      }
      
      if (siniestrosMarcados != ""){
        siniestrosMarcados = siniestrosMarcados.slice(0, -1)
        apiDevolucion
          .autorizar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            siniestrosMarcados
          )
          .then(response => {
            this.$Progress.finish();
            this.crearNotificacion(
                "Autorizar",
                "Se han guardado las autorizaciones seleccionas.",
                "success"
              );
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
    },

    rechazarMasivo(){
      this.modalDataObservacion.observacion = "";
      this.modalDataObservacion.individual = false;
      this.modalDataObservacion.slqdevolucion = "";
      this.modalRechazar = false;
      this.modalObservacion = true;
    },

    rechazarIndividual(){
      this.modalDataObservacion.observacion = "";
      this.modalDataObservacion.individual = true;
      this.modalDataObservacion.slqdevolucion = this.dataCalDevolucion.slqdevolucion;
      this.modalDetalle = false;
      this.modalObservacion = true;
    },

    confirmaRechazo(obs){
      console.log("confirmaRechazo");
      this.$Progress.start();
      var siniestrosMarcados = "";
      var index = 0;
      var observacion = "";

      if (obs){
        observacion = this.modalDataObservacion.observacion;
      }

      if (this.modalDataObservacion.individual){
        siniestrosMarcados = this.modalDataObservacion.slqdevolucion + ',';
      }
      else{

        /* solo los marcados y filtrados */
        var filtrados = this.$refs.refTable1.tableData;
        const names = filtrados.map(el => el.SLQDEVOLUCION);
        var marcados = new Array();

        for (var index = 0; index < this.multipleSelection.length; ++index) {
            if (names.includes(this.multipleSelection[index]["SLQDEVOLUCION"])){
              marcados.push(this.multipleSelection[index]);
            }
        }
        /* -- */

        for (index = 0; index < marcados.length; ++index) {
          siniestrosMarcados += marcados[index]["SLQDEVOLUCION"] + ',';
        }
      }

      if (siniestrosMarcados != ""){
        siniestrosMarcados = siniestrosMarcados.slice(0, -1)
        apiDevolucion
          .rechazar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            siniestrosMarcados,
            observacion
          )
          .then(response => {
            this.$Progress.finish();
            this.crearNotificacion(
                "Rechazar",
                "Se han guardado los rechazos seleccionados.",
                "success"
              );
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
    },

    detalleBeneficiarios(siniestro, p_modal){
      apiDevolucion
          .recuperar_beneficiario(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            siniestro
          )
          .then(response => {
            this.$Progress.finish();
            this.dataBeneficiarios = response.data.res1;
            this.modalBeneficiarios = p_modal;
          })
          .catch(error => {
            this.modalBeneficiarios = false;
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    }

  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar_vb();
  },
  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    },
    data: function() {
      this.$nextTick(function() {
        this.$refs.refTable1.$children[0].clearSelection();
        var lista = this.data;
        var index = 0;
        for (index = 0; index < lista.length; ++index) {
            this.toggleSelection([lista[index]]);
        }
      })
    }
  }
};
</script>


<style scoped>
.modal-xl {
  max-width: 90% !important;
}
</style>